import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import {
  CTA,
  CustomInput,
  CustomSelect,
  Icon,
  NoResult,
  Text,
} from '../../../ui/atoms';
import {
  Filter,
  SelectsContainer,
  FiltersContainer,
  ResultsSorting,
  EventCard,
  EventLegend,
  SupervisorBox,
} from './style';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../redux/actions';
import {
  APPROVAL_STATUS_OPTIONS,
  VISIBILITY_OPTIONS,
} from '../../../utils/labels';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';
import SortBy from '../../../ui/atoms/SortBy';
import { flattenCategories } from '../../../utils/categories';
import {
  TUTOR_COURSE_DELETE,
  TUTOR_EVENT_LIST_GET,
} from '../../redux/actions/tutorCourseList';
import Pagination from '../../../ui/atoms/Pagination';
import routes from '../../../routes';
import ModalConfirm, {
  ModalConfirmId,
} from '../../../ui/atoms/Modals/ModalConfirm';
import { timestampToDate } from '../../../utils/common';
import MultiActions from '../../../ui/atoms/MultiActions';
import theme from '../../../ui/theme';
import { APPROVAL_REQUESTS_GET } from '../../redux/actions/eventApproval';

const GetApprovalLabel = ({ item }) => {
  if (item?.approval_status === 'REJECTED') {
    return (
      <Text type="b4" color={theme().colors.fail}>
        Richiesta di modifica{' '}
        <Icon
          type="alert-triangle"
          clickable={false}
          stroke={theme().colors.fail}
        />
      </Text>
    );
  }
  return (
    <Text type="b4">
      {item?.approval_status === 'APPROVED'
        ? 'Approvato'
        : 'In attesa di approvazione'}
    </Text>
  );
};
GetApprovalLabel.propTypes = {
  item: PropTypes.object,
};

const EventList = ({
  mediaIsPhone,
  mediaIsTablet,
  active,
  isSupervisor,
  categories,
  filters,
  list,
  pager,
  getEventList,
  modalOpen,
  deleteCourse,
  getApprovalList,
  newRequests,
}) => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState();
  const [subjects, setSubjects] = useState([]);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    if (isSupervisor) {
      getApprovalList({ approval_status: 'TO_BE_APPROVED', typology: 'event' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupervisor]);

  useEffect(() => {
    return () => {
      setSelectedFilters({});
      setSubjects([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedFilters?.category) {
      const currentCategory = categories?.find(
        (c) => c?.id === selectedFilters?.category
      );
      const newSubjects = flattenCategories(currentCategory?.children, 0, true);
      setSubjects(newSubjects);
    } else setSubjects([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters?.category]);

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value || value;
    setSelectedFilters(newFilters);
  };

  const handleGetEvents = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      parent_categories: selectedFilters?.category,
      single_categories: selectedFilters?.subject,
      page,
    };
    if (parsedFilters?.subject) {
      delete parsedFilters?.parent_categories;
    }
    delete parsedFilters.category;
    delete parsedFilters.subject;
    getEventList(parsedFilters);
  };

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const loadMore = (page) => handleGetEvents(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  const getActions = (item) => {
    if (item?.owner) {
      return [
        {
          label: 'Modifica',
          icon: 'edit-05',
          onClick: () => navigate(`${routes.editEvent.path}/${item.id}`),
        },
        {
          label: 'Elimina',
          icon: 'trash-01',
          onClick: () => {
            setSelectedItem(item);
            modalOpen(ModalConfirmId);
          },
        },
      ];
    }
    return [
      {
        label: 'Modifica',
        icon: 'edit-05',
        onClick: () => navigate(`${routes.editEvent.path}/${item.id}`),
      },
    ];
  };

  return (
    <>
      <div>
        {isSupervisor && newRequests.list.length > 0 && (
          <SupervisorBox>
            <Text type="b3">
              Hai delle richieste in sospeso da revisionare. Clicca su “gestione
              richieste” per visualizzare la sezione dedicata.
            </Text>
            <CTA
              type="tertiary"
              btnText="Gestione richieste di approvazione"
              icon="arrow-narrow-right"
              onClick={() => navigate(routes.approvalList.path)}
              bottomRight={mediaIsPhone || mediaIsTablet}
            />
          </SupervisorBox>
        )}
        {mediaIsPhone ? (
          <>
            <StickyFiltersWrapper mb={16} stickyPosition={0}>
              <CustomInput
                placeholder="Cosa vuoi cercare?..."
                isSearch
                value={searchValue}
                icon="search-sm"
                isClearable
                onChange={(v) => setSearchValue(v)}
                onClickIcon={onClickSearch}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') onClickSearch();
                }}
              />
              <CTA
                classes="small-btn"
                btnText="Filtri"
                type="secondary"
                onClick={() =>
                  modalOpen(ModalFiltersId, {
                    filters: {
                      category: categories,
                      subject: subjects,
                      ...filters,
                      course_status: VISIBILITY_OPTIONS,
                    },
                    activeFilters: selectedFilters,
                  })
                }
              />
            </StickyFiltersWrapper>
            <Text type="b3" mb={24}>
              {pager?.total_items || 0} percorsi formativi disponibili
            </Text>
          </>
        ) : (
          <>
            <FiltersContainer>
              <SelectsContainer>
                <Filter>
                  <CustomInput
                    placeholder="Cosa vuoi cercare?..."
                    isSearch
                    value=""
                    icon="search-sm"
                    isClearable
                    onChange={(v) => setSearchValue(v)}
                    onClickIcon={onClickSearch}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') onClickSearch();
                    }}
                  />
                </Filter>
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Area tematica"
                    options={categories}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        category: v?.id,
                      })
                    }
                    selected={
                      categories?.find(
                        (c) => c.id === selectedFilters?.category
                      ) ?? null
                    }
                  />
                </Filter>
                {subjects?.length > 0 && (
                  <Filter>
                    <CustomSelect
                      size="s"
                      placeholder="Materia"
                      options={subjects}
                      isClearable
                      onChange={(v) =>
                        setSelectedFilters({
                          ...selectedFilters,
                          subject: v?.value,
                        })
                      }
                      selected={
                        subjects?.find(
                          (s) => s.value === selectedFilters?.subject
                        ) ?? null
                      }
                    />
                  </Filter>
                )}
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Stato"
                    options={VISIBILITY_OPTIONS}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        course_status: v?.value,
                      })
                    }
                  />
                </Filter>
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Stato approvazione"
                    options={APPROVAL_STATUS_OPTIONS}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        approval_status: v?.value,
                      })
                    }
                  />
                </Filter>
              </SelectsContainer>
            </FiltersContainer>
            <ResultsSorting>
              <Text type="b3">
                {pager?.total_items || 0} percorsi formativi disponibili
              </Text>
              <SortBy
                onChange={(v) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    sort_by: v?.value,
                  });
                }}
              />
            </ResultsSorting>
          </>
        )}
        {list?.length > 0 ? (
          <>
            {!(mediaIsPhone || mediaIsTablet) && (
              <EventLegend>
                <Text type="h3.5">CODICE</Text>
                <Text type="h3.5">TITOLO PERCORSO FORMATIVO</Text>
                <Text type="h3.5">AREA TEMATICA</Text>
                <Text type="h3.5">MATERIA</Text>
                <Text type="h3.5">STATO</Text>
                <Text type="h3.5">Stato Approvazione</Text>
                <Text type="h3.5">Data di creazione</Text>
              </EventLegend>
            )}
            {list.map((item, i) => {
              if (mediaIsPhone || mediaIsTablet) {
                return (
                  <EventCard
                    key={`course-${item?.id}`}
                    className={i + 1 === list?.length ? 'last' : ''}
                  >
                    <div />
                    <MultiActions actions={getActions(item)} />
                    <Text type="h5">Codice</Text>
                    <Text type="h3">{item?.code || '-'}</Text>
                    <Text type="h5">TITOLO PERCORSO FORMATIVO </Text>
                    <Text type="h3">{item?.title}</Text>
                    <Text type="h5">AREA TEMATICA </Text>
                    <Text type="b4" className="category">
                      {item?.category}
                    </Text>
                    <Text type="h5">MATERIA </Text>
                    <Text type="b4" className="category">
                      {item?.subject || '-'}
                    </Text>
                    <Text type="h5">Stato </Text>
                    <Text type="b4" className="category">
                      {item?.published ? 'Visibile' : 'Non visibile'}
                    </Text>
                    <Text type="h5">Stato di approvazione</Text>
                    <GetApprovalLabel item={item} />
                    <Text type="h5">Data di creazione</Text>
                    <Text type="b4">{timestampToDate(item?.created)}</Text>
                  </EventCard>
                );
              }

              return (
                <EventCard
                  key={`course-${item?.id}`}
                  className={i + 1 === list?.length ? 'last' : ''}
                >
                  <Text type="b5">{item?.code}</Text>
                  <Text type="h3">{item?.title}</Text>
                  <Text type="b4" className="category">
                    {item?.category}
                  </Text>
                  <Text type="b4" className="category">
                    {item?.subject || '-'}
                  </Text>
                  <Text type="b4" className="category">
                    {item?.published ? 'Visibile' : 'Non visibile'}
                  </Text>
                  <Text type="b4">
                    <GetApprovalLabel item={item} />
                  </Text>
                  <Text type="b4">{timestampToDate(item?.created)}</Text>
                  <MultiActions actions={getActions(item)} />
                </EventCard>
              );
            })}
          </>
        ) : (
          <NoResult />
        )}
        <Pagination
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
      {active && (
        <>
          {mediaIsPhone && (
            <ModalFilters
              onClick={(newFilters) =>
                setSelectedFilters({
                  ...newFilters,
                  search_text: selectedFilters.search_text,
                })
              }
            />
          )}
          <ModalConfirm
            onClick={() => {
              deleteCourse({
                id: selectedItem.id,
                callback: handleGetEvents,
              });
            }}
            title="Attenzione"
          >
            <Text type="b3">
              Cliccando su "Conferma" canecellerai il corso{' '}
              <b>"{selectedItem?.title}"</b>.
            </Text>
            <Text type="b3"> Il processo non è reversibile.</Text>
          </ModalConfirm>
        </>
      )}
    </>
  );
};

EventList.propTypes = {
  active: PropTypes.bool,
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // HOC (connect, state)
  isSupervisor: PropTypes.bool,
  categories: PropTypes.array,
  filters: PropTypes.object,
  list: PropTypes.array,
  pager: PropTypes.object,
  newRequests: PropTypes.object,
  // HOC (connect, dispatch)
  modalOpen: PropTypes.func.isRequired,
  getEventList: PropTypes.func.isRequired,
  deleteCourse: PropTypes.func.isRequired,
  getApprovalList: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { isSupervisor } = state.user;
      const { list, pager } = state.tutorCourseList.eventList;
      const { categories } = state.courselist;
      const { newRequests } = state.eventApproval;
      return { isSupervisor, categories, list, pager, newRequests };
    },
    (dispatch) => ({
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
      getEventList: (filters = {}) =>
        dispatch({ type: TUTOR_EVENT_LIST_GET._REQUEST, filters }),
      deleteCourse: ({ id, callback }) =>
        dispatch({ type: TUTOR_COURSE_DELETE._REQUEST, id, callback }),
      getApprovalList: (filters) =>
        dispatch({ type: APPROVAL_REQUESTS_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(EventList);
